// extracted by mini-css-extract-plugin
export var content = "_4n-3";
export var list = "_4n-4";
export var settingsContent = "_4n-7";
export var settingsPanel = "_4n-8";
export var state = "_4n-6";
export var triggerBadge = "_4n-2";
export var triggerButton = "_4n-1";
export var triggerShell = "_4n-0";
export var unreadDot = "_4n-5";